import fetchWithApiKey from '../util/fetchWithApiKey';

class Stagiaire {
  async postuler(formData) {
    try {
      const apiUrl = 'https://stagiaires.visibilitycam.com';
      const response = await fetchWithApiKey(`${apiUrl}/api/postuler-stage`, {
        method: 'POST',
        body: formData,
      });

      return response;
    } catch (error) {
      console.error('Erreur lors de la soumission de la candidature :', error);
      throw error;
    }
  }
}

export default Stagiaire;